import React from 'react';
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid } from 'recharts';

// Artifact emitted by the get_etf_holdings tool (kind: "etf_holdings").
export interface EtfHoldingsData {
  name: string;
  ticker: string;
  as_of?: string;
  total_holdings?: number;
  holdings: { identifier: string; name: string; weight: number; sector?: string; country?: string }[];
}

const NAVY = '#000537';
const pct = (v: number) => `${(v * 100).toFixed(1)}%`;

const EtfHoldingsChart: React.FC<{ data: EtfHoldingsData }> = ({ data }) => {
  const rows = (data.holdings || []).slice(0, 15).map((h) => ({ name: h.name, weight: h.weight }));

  return (
    <div className="chart-card">
      <div className="d-flex justify-content-between align-items-baseline" style={{ marginBottom: 12 }}>
        <span className="fw-semibold" style={{ fontSize: '0.85rem', color: NAVY }}>
          {data.name} <span style={{ color: '#a1a1aa', fontWeight: 400 }}>{data.ticker}</span> — top holdings
        </span>
        <span style={{ fontSize: '0.72rem', color: '#a1a1aa' }}>
          {data.total_holdings ? `${data.total_holdings} holdings` : ''}{data.as_of ? ` · ${data.as_of}` : ''}
        </span>
      </div>

      {rows.length > 0 ? (
        <ResponsiveContainer width="100%" height={Math.max(160, rows.length * 26)}>
          <BarChart layout="vertical" data={rows} margin={{ top: 4, right: 28, bottom: 0, left: 8 }}>
            <CartesianGrid horizontal={false} stroke="#f1f1f3" />
            <XAxis type="number" tickFormatter={pct} tick={{ fontSize: 11, fill: '#71717a' }} />
            <YAxis type="category" dataKey="name" width={150} tick={{ fontSize: 11, fill: '#3f3f46' }} />
            <Tooltip formatter={(v: number) => pct(v)} contentStyle={{ fontSize: 12, borderRadius: 8 }} />
            <Bar dataKey="weight" fill={NAVY} radius={[0, 3, 3, 0]} />
          </BarChart>
        </ResponsiveContainer>
      ) : (
        <div style={{ fontSize: '0.8rem', color: '#a1a1aa' }}>No holdings available.</div>
      )}
    </div>
  );
};

export default EtfHoldingsChart;
